'use client';

import { useTranslations } from 'next-intl';

import { levelsMock } from '../../mock';
import { LevelCard } from '../LevelCard/LevelCard';

import { styles } from './LevelsSection.styles';

interface LevelsSectionProps {
  onClick: () => void;
  onTypeSkinClick: () => void;
}

export function LevelsSection({
  onClick,
  onTypeSkinClick
}: LevelsSectionProps) {
  const slots = styles();

  const t = useTranslations('article.page.loyalty.levels');

  const { levels } = levelsMock(onClick, onTypeSkinClick);

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{t('title')}</h2>
      <div className={slots.description()}>{t('description')}</div>
      <div className={slots.levels()}>
        {levels.map((level, index) => (
          <div
            key={index}
            className={slots.level()}
          >
            <LevelCard
              level={index + 1}
              cashback={level.cashbackPoints}
              description={level.description}
              privileges={level.privileges}
              steps={level.steps}
              color={index % 2 === 0 ? 'primary' : 'secondary'}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
